export enum PAYMENT_METHOD_PERMISSIONS {
  PAYMENT_METHOD_VIEW = 'PAYMENT_METHODVIEW',
  PAYMENT_METHOD_WRITE = 'PAYMENT_METHODWRITE',
  PAYMENT_FACTURATION_CONFIG = 'PAYMENT_FACTURATIONCONFIG',
}
